/* Publish by EComposer at 2026-10-23 05:53:55*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ejmtfy64nvh"]=  window.__ectimmers["ecom-ejmtfy64nvh"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ejmtfy64nvh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ejmtfy64nvh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ic43a8291b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ic43a8291b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0woc5zlifkxf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0woc5zlifkxf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-26mjkfmw91j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-26mjkfmw91j', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}